import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export const useDelayedNavigation = () => {
  const navigate = useNavigate();

  const delayedNavigate = useCallback((path: string, options?: { state?: any; delay?: number }) => {
    const delay = options?.delay || 1000;
    setTimeout(() => {
      navigate(path, options?.state ? { state: options.state } : undefined);
    }, delay);
  }, [navigate]);

  return delayedNavigate;
};
